
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[modelId]/[modelSlug]",
      function () {
        return require("private-next-pages/[modelId]/[modelSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[modelId]/[modelSlug]"])
      });
    }
  